import { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';
class ReactResizeObserver extends PureComponent {
    constructor() {
        super(...arguments);
        this.resizeObserver = null;
        this.width = 0;
        this.height = 0;
        this.onResize = (entries) => {
            const { onResize, resizeProp, boxSize } = this.props;
            const [entry] = entries;
            const { target, contentRect, } = entry;
            const { borderBoxSize } = entry;
            const borderBox = borderBoxSize && borderBoxSize[0];
            const isBorderBox = boxSize === 'borderBox';
            const { width, height } = (() => {
                if (isBorderBox) {
                    if (borderBox) {
                        return { width: borderBox.inlineSize, height: borderBox.blockSize };
                    }
                    return target.getBoundingClientRect();
                }
                return contentRect;
            })();
            const fixedWidth = Math.round(width);
            const fixedHeight = Math.round(height);
            if ((this.width !== fixedWidth && ['width', 'both'].includes(resizeProp)) ||
                (this.height !== fixedHeight && ['height', 'both'].includes(resizeProp))) {
                this.width = fixedWidth;
                this.height = fixedHeight;
                if (onResize) {
                    onResize(fixedWidth, fixedHeight, target);
                }
            }
        };
    }
    componentDidMount() {
        this.onComponentUpdated();
    }
    componentDidUpdate() {
        this.onComponentUpdated();
    }
    componentWillUnmount() {
        this.destroyObserver();
    }
    onComponentUpdated() {
        const { disabled } = this.props;
        const element = findDOMNode(this);
        if (!this.resizeObserver && !disabled && element) {
            // Add resize observer
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(element);
            const { onResize, immediately } = this.props;
            if (immediately && onResize) {
                onResize(element.offsetWidth, element.offsetHeight, element);
            }
        }
        else if (disabled) {
            // Remove resize observer
            this.destroyObserver();
        }
    }
    destroyObserver() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
    render() {
        const { children = null } = this.props;
        return children;
    }
}
ReactResizeObserver.defaultProps = {
    resizeProp: 'both',
    boxSize: 'borderBox',
};
export default ReactResizeObserver;
